import { useEffect, useState } from "react";
import formatMoney from "src/utils/formatMoney";
import { InputText } from "./InputText";

interface Props {
  value?: string | number;
  onChange?: (value: number) => void;
  placeholder: string;
  suffix?: string;
  maxLength?: number;
  disabled?: boolean;
  allowClear?: boolean;
  className?: string;
}

export default function InputCurrency(props: Props) {
  // console.log("props.value", props.value);

  const [amount, setAmount] = useState(
    props.value || props.value === 0
      ? typeof props.value === "string"
        ? formatMoney(props.value.replace(".", "").replace(",", "") as any)
        : formatMoney(props.value)
      : ""
  );

  useEffect(() => {
    if (amount && !props.value && props.value !== 0) {
      setAmount("");
    }
  }, [props.value]);

  function handleChange(input) {
    let inputRaw = input && input.match(/\d/g);

    if (!inputRaw) {
      if (props.allowClear) {
        setAmount("");
        props.onChange(null);
      }

      return;
    }

    inputRaw = inputRaw.join("");

    const newAmount = (inputRaw / 100).toLocaleString("en-US", {
      style: "decimal",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    const amountNumber = parseInt(inputRaw, 10);

    setAmount(newAmount);
    props.onChange(amountNumber);
  }

  return (
    <InputText
      value={amount}
      name="amount"
      type="tel"
      onChange={handleChange}
      prefix="$"
      suffix={props.suffix}
      placeholder={props.placeholder}
      maxLength={props.maxLength ?? 8}
      disabled={props.disabled}
      allowClear={props.allowClear}
      className={props.className}
    />
  );
}
